"use strict";

module.exports = function (condition, succeed, fail) {
  return function () {
    if (condition.apply(undefined, arguments)) {
      return succeed.apply(undefined, arguments);
    }
    return fail.apply(undefined, arguments);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/functional/ifn.js
// module id = 2169
// module chunks = 37